import { loadFormCallback, whenReady, whenRenderedCallback } from './formEvents';

export function scriptLoaded({
  formId,
  formLoaded,
  setFormLoaded,
  setFormUnavailable,
  isMounted,
  intervalId,
  handleSuccess,
  onFormLoaded,
  addHiddenFields,
  productOfInterest,
}) {
  if (typeof window === 'undefined') return;
  let mktoReady = false;
  let formIsLoading = false;
  let checkTime = 500;
  let tries = 0;
  let maxTries = 30;

  intervalId.current = setInterval(() => {
    if (!isMounted.current) {
      clearInterval(intervalId.current);
      return;
    }

    if (tries === maxTries && !window.MktoForms2) {
      clearInterval(intervalId.current);
      if (typeof window !== 'undefined' && !!window.FS) {
        window.FS.event('Marketo Form', {
          type: 'Form failed to load',
          formID: (formId && formId.toString()) || '',
        });
      }
      setFormUnavailable(true);
      setFormLoaded(true);
      return;
    }

    tries++;

    if (typeof window !== 'undefined' && [30, 60, 120].includes(tries)) {
      const consent = window.Osano?.cm?.getConsent();
      const timeMsg =
        tries === 30
          ? 'No form load after 15 seconds'
          : tries === 60
          ? 'No form load after 30 seconds'
          : 'No form load after 1 minute';

      window.FS.event('Marketo Form', {
        type: timeMsg,
        formID: (formId && formId.toString()) || '',
        consent,
      });
    }

    if (!!window.MktoForms2) {
      mktoReady = true;
      // we intentionally do NOT clear here, because we want to defer until after form is loaded
    }

    if (mktoReady && !formLoaded && !formIsLoading) {
      formIsLoading = true;
      clearInterval(intervalId.current); // make sure it runs only once
      const start = performance.now();
      let slug;
      if (typeof window !== 'undefined' && window.location) {
        slug = window.location.pathname;
      }

      window.MktoForms2.loadForm(process.env.GATSBY_FORM_HOST, '002-LDF-436', formId.toString(), (form) =>
        loadFormCallback(form, isMounted.current, () => handleSuccess(form.getValues()), slug)
      )
        .whenReady(async (form) => {
          await whenReady(form, addHiddenFields, start, null, productOfInterest);
          if (isMounted.current) {
            setFormLoaded(true);
            onFormLoaded && onFormLoaded(true);
          }
        })
        .whenRendered(whenRenderedCallback);
    }
  }, checkTime);
}

export function handleDemoButton(productOfInterest) {
  if (typeof window === 'undefined') return;
  const urlParams = new URLSearchParams(window.location.search);
  const productUtm = urlParams.get('utm_product');
  if (productUtm) return;
  const demoBtn = window.document.querySelector('a[href*="/demo"]');
  const productLookup = {
    Analytics: 'AN',
    'Story AI': 'SA',
    Workforce: 'WF',
    Anywhere: 'AW',
  };
  if (productOfInterest) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('fs_product');
    urlParams.set('fs_product', productLookup[productOfInterest]);
    const updatedParams = urlParams.toString();

    demoBtn?.setAttribute('href', `/demo/?${updatedParams}`);
  }
}
